import "./PujaView.scss";
import { Box, Grid, Typography, Stack } from "@mui/material";

import vertorArtLeft from "../../assets/vector-art-left.png";
import vertorArtRight from "../../assets/vector-art-right.png";
import omLiner from "../../assets/om-liner.png";
import PujaListCard from "../../components/card/Puja/PujaListCard";
import ShareLink from "../../components/sharelink/sharelink";
import { useEffect, useState } from "react";
import ImageViewerWithBlur from "../../components/imageviewer/ImageViewerWithBlur";
import {
  getCityStateFromTemple,
  getMaxAllowedMember,
  getOfferPriceFromV1,
  getOneImageForTemple,
  getTempleName,
} from "../../utils/HelperFunctions";
import { useSelector } from "react-redux";
import { LOCALSTORAGE_KEY, orderType } from "../../utils/Constants";
import TempleServiceListCard from "../../components/card/TempleServiceListCard/TempleServiceListCard";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import MasonryGrid from "../../components/MasonryGrid/MasonryGrid";

function PromotionalPujaView(props: any) {
  const [urlToShare, setUrlToShare] = useState<string>("");
  const [
    slectedPromotionalPujaOrganisations,
    setSlectedPromotionalPujaOrganisations,
  ] = useState<any>([]);
  const { t } = useTranslation();

  const priceConversionState = useSelector(
    (state: any) => state?.priceConversion,
  );

  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState?.priceConversionRate || {};

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
    
  useEffect(() => {
    // const params = new URLSearchParams(location.search);
    // const promotionalPujaId = params.get('pujaNameKey')
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?specialPuja=${props?.promotionalPujaDetails?.pujaNameKey}`,
    );
  }, [props.promotionalPujaDetails]);

  return (
    <Box className="pageContainer promotionalPujaPage templePage">
      <Box className="templeBlock">
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} lg={2} xl={2} className="templeLeftBlock">
            {/* <LeftAddressCard
              header={props.TDTexts.CURRENTADDRESS}
              address={
                props.userAddressList && props.userAddressList.length > 0
                  ? props.userAddressList[0].formatted_address
                  : ""
              }
              footerButton="Edit or add an address"
            /> */}
          </Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="promoPujaCenterBlock" data-scroll-id={"special-Chadhava-banner"}>
              <Box>
                {/* <img
                  className="promoPujaBanner"
                  src={props.promotionalPujaDetails?.pujaListBg?.uri}
                  alt={"Image"}
                /> */}

                <ImageViewerWithBlur
                  key={"promo-puja"}
                  id={"promo-puja"}
                  url={props.promotionalPujaDetails?.pujaListBg?.uri}
                />
              </Box>
              <Box className="shareIcon">
                <ShareLink urlToShare={urlToShare} type="Promotional Puja"></ShareLink>
              </Box>

              {props.slectedPromotionalPujaOrganisations &&
              props.slectedPromotionalPujaOrganisations.length > 0
                ? props.slectedPromotionalPujaOrganisations.map(
                    (item: any, index: number) => {
                      if (!item.templePuja || item.templePuja.length === 0) {
                        return <Box key={`empty-${index}`} />;
                      }

                      return (
                        <Box key={item.id || `pujaBooking-${index}`}>
                          <Box className="pujaBookingTitle">
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Typography>
                                {item?.personalInfo?.name}
                              </Typography>
                              <Box className="textBottomLiner">
                                <img src={omLiner} alt="om Liner" />
                              </Box>
                            </Stack>
                          </Box>

                          <Box className="templeCenterBlock" data-scroll-id={"special-puja-Details"}>
                            <MasonryGrid
                              items={item.templePuja}
                              renderItem={(itemPuja: any, idPuja: number) => {
                                const templeName = getTempleName(
                                  { personalInfo: item?.personalInfo },
                                  savedLanguage,
                                );

                                const templeAddress = getCityStateFromTemple(
                                  item?.personalInfo,
                                );

                                const templeCardImage =
                                  itemPuja?.pujaBg?.uri ||
                                  getOneImageForTemple(
                                    item?.personalInfo?.media?.pictures,
                                  );

                                const basePrice = isOverseas
                                  ? itemPuja?.overseasBasicPrice
                                  : itemPuja?.indianBasicPrice;

                                const finalTotalPrice =
                                  basePrice > 0
                                    ? parseFloat((basePrice * rate).toFixed(2))
                                    : 0;

                                const offerV1 = itemPuja?.multiplePujaDetails
                                  ?.length
                                  ? itemPuja?.multiplePujaDetails[0]
                                      ?.priceBreakupV1
                                  : null;

                                const offerActualPrice = getOfferPriceFromV1(
                                  offerV1,
                                  isOverseas,
                                  false,
                                  rate,
                                );

                                const serviceBenefits =
                                  itemPuja?.benefitList?.map(
                                    (bnft: any) => bnft?.name,
                                  ) || [];

                                const serviceTitle =
                                  item?.type === orderType?.pujaPackage
                                    ? itemPuja?.cardTitle || ""
                                    : itemPuja?.pujaSpecialDesc || "";

                                return (
                                  <TempleServiceListCard
                                    key={idPuja}
                                    templeData={{
                                      pujaDetails: { ...itemPuja },
                                    }}
                                    templeName={templeName}
                                    templeAddress={templeAddress}
                                    templeCardImage={templeCardImage}
                                    overlayText={{
                                      leftSideTextOverlay:
                                        itemPuja?.leftSideTextOverlay,
                                      rightSideTextOverlay:
                                        itemPuja?.rightSideTextOverlay,
                                    }}
                                    overlayCss={itemPuja?.overlayCss ?? null}
                                    serviceTitle={serviceTitle}
                                    serviceDescription={itemPuja?.pujaName}
                                    serviceBenefits={serviceBenefits}
                                    serviceThithiName={
                                      itemPuja?.tithiName || ""
                                    }
                                    finalTotalPrice={finalTotalPrice}
                                    offerActualPrice={offerActualPrice}
                                    currencySymbols={currencySymbols}
                                    type={itemPuja?.puja}
                                    selectTemple={() =>
                                      props?.onClickParticipate(
                                        item?.nameKey,
                                        itemPuja?.pujaNameKey,
                                      )
                                    }
                                    actionLabel={t(
                                      LOCALIZATION?.View_to_participate,
                                    )}
                                  />
                                );
                              }}
                            />
                          </Box>
                        </Box>
                      );
                    },
                  )
                : null}
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="templeRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default PromotionalPujaView;
